var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "header" }, [
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.systemName))]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "login" },
      [
        _c(
          "a-form",
          { attrs: { form: _vm.form }, on: { submit: _vm.onSubmit } },
          [
            _c(
              "a-tabs",
              {
                staticStyle: { padding: "0 2px" },
                attrs: { size: "large", tabBarStyle: { textAlign: "center" } },
              },
              [
                _c(
                  "a-tab-pane",
                  { key: "1", attrs: { tab: "账户密码登录" } },
                  [
                    _c("a-alert", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.error,
                          expression: "error",
                        },
                      ],
                      staticStyle: { "margin-bottom": "24px" },
                      attrs: {
                        type: "error",
                        closable: true,
                        message: _vm.error,
                        showIcon: "",
                      },
                    }),
                    _c(
                      "a-form-item",
                      [
                        _c(
                          "a-input",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "username",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "请输入账户名",
                                        whitespace: true,
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "['username', {rules: [{ required: true, message: '请输入账户名', whitespace: true}]}]",
                              },
                            ],
                            attrs: {
                              autocomplete: "autocomplete",
                              size: "large",
                              placeholder: "请输入账户名",
                            },
                          },
                          [
                            _c("a-icon", {
                              attrs: { slot: "prefix", type: "user" },
                              slot: "prefix",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      [
                        _c(
                          "a-input",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "password",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "请输入密码",
                                        whitespace: true,
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "['password', {rules: [{ required: true, message: '请输入密码', whitespace: true}]}]",
                              },
                            ],
                            attrs: {
                              size: "large",
                              placeholder: "请输入密码",
                              autocomplete: "autocomplete",
                              type: "password",
                            },
                          },
                          [
                            _c("a-icon", {
                              attrs: { slot: "prefix", type: "lock" },
                              slot: "prefix",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "a-form-item",
              [
                _c(
                  "a-button",
                  {
                    staticStyle: { width: "100%", "margin-top": "24px" },
                    attrs: {
                      loading: _vm.logging,
                      size: "large",
                      htmlType: "submit",
                      type: "primary",
                    },
                  },
                  [_vm._v("登录 ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }